
import { getLanguage } from "../services/languageService";

export const getCurrentLanguage = () => {
    return getLanguage() || "FR";
};


export const getLabel = (object, fieldName) => {
    if (!object)
        return "";

    const lang = getCurrentLanguage();

    if (lang === "AR") {

        return (
            object[fieldName + "Arab"] ??
            object[fieldName] ??
            ""
        );

    }

    if (lang === "EN") {

        return (
            object[fieldName + "Ang"] ??
            object[fieldName] ??
            ""
        );

    }

    return object[fieldName] ?? "";

};

/**
 * Retourne une liste de libellés
 */
export const getLabels = (
    list,
    fieldName,
    separator = ", "
) => {

    if (!list || list.length === 0)
        return "";

    return list
        .map(item => getLabel(item, fieldName))
        .join(separator);

};